
import getDemoData from '../fixtures/demos';
import _ from 'lodash';
import { extract } from '../helpers';

const key = '/api/lives/demo';

export const getData = () => localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : getDemoData();

export const addAction = action => {
    const idLast = _.last(getData().actions)['@id'];
    const response = {
        ...getData(), 
        actions: [
            ...getData().actions, 
            {
                '@id': `/api/actions/${_.toNumber(extract(idLast, '/', 3)+1)}`, 
                teamId: action.teamId,
                teamName: action.teamName,
                minute: action.minute,
                data: action.data,
                type: action.type
            }
        ]
    }
    localStorage.setItem(key, JSON.stringify(response));
    return response;
}

export const edit = body => _.assign(getData(), body);